(function () {
  'use strict';

  document.querySelectorAll('[data-efr-root]').forEach(function (root) {

    var node =
      root.querySelector('[data-efr-product-json]');

    if (!node) return;


    var product;

    try {

      product =
        JSON.parse(node.textContent);

    } catch (error) {

      return;

    }


    var buttons = Array.from(
      root.querySelectorAll('[data-efr-scent]')
    );


    var resultText =
      root.querySelector(
        '[data-efr-result-scent]'
      );


    var resultImage =
      root.querySelector(
        '[data-efr-result-image]'
      );


    var priceText =
      root.querySelector(
        '[data-efr-result-price]'
      );


    var status =
      root.querySelector(
        '[data-efr-status]'
      );


    var add =
      root.querySelector(
        '[data-efr-add]'
      );


    var finalSelect =
      root.querySelector(
        '[data-efr-final-select]'
      );


    var finalImage =
      root.querySelector(
        '[data-efr-final-image]'
      );


    var finalPrice =
      root.querySelector(
        '[data-efr-final-price]'
      );


    var finalAdd =
      root.querySelector(
        '[data-efr-final-add]'
      );


    var paymentButton =
      root.querySelector(
        '.efr-product-form .shopify-payment-button'
      );


    var selected = '';


    /* =========================
       HELPERS
    ========================= */

    function norm(value) {

      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(
          /[\s　_\-・]/g,
          ''
        );

    }


    function money(cents) {

      return (
        '¥' +
        Math.round(
          Number(cents || 0) / 100
        ).toLocaleString('ja-JP') +
        '（税込）'
      );

    }


    function findVariant() {

      if (!selected) {
        return null;
      }


      return (
        product.variants || []
      ).find(
        function (variant) {

          return (
            variant.options || []
          ).some(
            function (option) {

              return (
                norm(option) ===
                norm(selected)
              );

            }
          );

        }
      ) || null;

    }


    function findVariantByScent(
      scent
    ) {

      if (!scent) {
        return null;
      }


      return (
        product.variants || []
      ).find(
        function (variant) {

          return (
            variant.options || []
          ).some(
            function (option) {

              return (
                norm(option) ===
                norm(scent)
              );

            }
          );

        }
      ) || null;

    }


    function findVariantById(id) {

      if (!id) {
        return null;
      }


      return (
        product.variants || []
      ).find(
        function (variant) {

          return (
            String(variant.id) ===
            String(id)
          );

        }
      ) || null;

    }


    function findButtonForVariant(
      variant
    ) {

      if (!variant) {
        return null;
      }


      return buttons.find(
        function (button) {

          return (
            variant.options || []
          ).some(
            function (option) {

              return (
                norm(option) ===
                norm(
                  button.dataset.efrScent
                )
              );

            }
          );

        }
      ) || null;

    }


    function findButtonForSelected() {

      if (!selected) {
        return null;
      }


      return buttons.find(
        function (button) {

          return (
            norm(
              button.dataset.efrScent
            ) ===
            norm(selected)
          );

        }
      ) || null;

    }


    function setButtonState(
      activeButton
    ) {

      buttons.forEach(
        function (button) {

          var active =
            button === activeButton;


          button.classList.toggle(
            'is-selected',
            active
          );


          button.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );

        }
      );

    }


    /* =========================
       STOCK
    ========================= */

    function setStockState(
      button,
      soldOut
    ) {

      button.disabled =
        soldOut;


      button.classList.toggle(
        'is-sold-out',
        soldOut
      );


      button.setAttribute(
        'aria-disabled',
        soldOut
          ? 'true'
          : 'false'
      );


      var label =
        button.querySelector(
          '.efr-stock-label'
        );


      if (soldOut) {

        if (!label) {

          label =
            document.createElement(
              'span'
            );


          label.className =
            'efr-stock-label';


          label.textContent =
            'SOLD OUT';


          label.setAttribute(
            'aria-label',
            '在庫切れ'
          );


          button.appendChild(
            label
          );

        }

      } else if (label) {

        label.remove();

      }

    }


    function getOriginalOptionLabel(
      option
    ) {

      if (
        !option.dataset.efrOriginalLabel
      ) {

        option.dataset.efrOriginalLabel =
          option.textContent
            .trim()
            .replace(
              /\s*｜SOLD OUT$/,
              ''
            );

      }


      return (
        option.dataset.efrOriginalLabel
      );

    }


    function refreshFinalSelectStock() {

      if (!finalSelect) {
        return;
      }


      Array.from(
        finalSelect.options
      ).forEach(
        function (option) {

          if (!option.value) {
            return;
          }


          var variant =
            findVariantById(
              option.value
            );


          var soldOut =
            !variant ||
            !variant.available;


          option.disabled =
            soldOut;


          option.textContent =
            getOriginalOptionLabel(
              option
            ) +
            (
              soldOut
                ? '｜SOLD OUT'
                : ''
            );

        }
      );

    }


    function refreshStock() {

      /*
        香りカード
      */

      buttons.forEach(
        function (button) {

          var scent =
            button.dataset.efrScent || '';


          var variant =
            findVariantByScent(
              scent
            );


          var soldOut =
            !variant ||
            !variant.available;


          setStockState(
            button,
            soldOut
          );

        }
      );


      /*
        下部購入フォーム
      */

      refreshFinalSelectStock();


      /*
        万一、現在選択中の香りが
        SOLD OUTなら解除
      */

      if (selected) {

        var currentVariant =
          findVariantByScent(
            selected
          );


        if (
          !currentVariant ||
          !currentVariant.available
        ) {

          selected = '';

          setButtonState(
            null
          );

        }

      }

    }


    /* =========================
       IMAGE
    ========================= */

    function getImage(
      button,
      variant
    ) {

      if (
        button &&
        button.dataset.efrImage
      ) {

        return (
          button.dataset.efrImage
        );

      }


      if (
        variant &&
        variant.image
      ) {

        return variant.image;

      }


      return '';

    }


    function getImageAlt(
      button
    ) {

      if (
        button &&
        button.dataset.efrImageAlt
      ) {

        return (
          button.dataset.efrImageAlt
        );

      }


      return (
        'ETERNAL FLOWER 専用レフィル 25ml'
      );

    }


    function setImage(
      imageNode,
      src,
      alt
    ) {

      if (
        !imageNode ||
        !src
      ) {

        return;

      }


      imageNode.src =
        src;


      if (alt) {

        imageNode.alt =
          alt;

      }

    }


    function syncImages(
      button,
      variant
    ) {

      var image =
        getImage(
          button,
          variant
        );


      var alt =
        getImageAlt(
          button
        );


      if (!image) {
        return;
      }


      setImage(
        resultImage,
        image,
        alt
      );


      setImage(
        finalImage,
        image,
        alt
      );

    }


    /* =========================
       FINAL FORM
    ========================= */

    function syncFinalForm(
      variant
    ) {

      /*
        未選択
      */

      if (!variant) {

        if (finalSelect) {

          finalSelect.value = '';

        }


        if (finalAdd) {

          finalAdd.disabled = true;

        }


        if (paymentButton) {

          paymentButton.style.display =
            'none';

        }


        return;

      }


      /*
        選択済み
      */

      if (finalSelect) {

        finalSelect.value =
          String(
            variant.id
          );


        finalSelect.dispatchEvent(
          new Event(
            'input',
            {
              bubbles: true
            }
          )
        );

      }


      if (finalPrice) {

        finalPrice.textContent =
          money(
            variant.price
          );

      }


      if (finalAdd) {

        finalAdd.disabled =
          !variant.available;

      }


      if (paymentButton) {

        paymentButton.style.display =
          variant.available
            ? ''
            : 'none';

      }

    }


    /* =========================
       MAIN UPDATE
    ========================= */

    function update() {


      /*
        最初に在庫状態を更新
      */

      refreshStock();


      var variant =
        findVariant();


      var button =
        findButtonForSelected();


      /*
        RESULT TEXT
      */

      if (resultText) {

        resultText.textContent =
          selected ||
          '香りを選択してください';

      }


      /*
        CENTER CART
      */

      if (add) {

        add.dataset.variantId =
          variant
            ? variant.id
            : '';


        add.disabled =
          !variant ||
          !variant.available;

      }


      /*
        未選択
      */

      if (!selected) {

        setButtonState(
          null
        );


        if (status) {

          status.textContent =
            '香りを1種類お選びください。';

        }


        syncFinalForm(
          null
        );


        return;

      }


      /*
        VARIANTなし
      */

      if (!variant) {

        if (status) {

          status.textContent =
            '選択した香りの商品情報が見つかりませんでした。商品オプション名をご確認ください。';

        }


        syncFinalForm(
          null
        );


        return;

      }


      /*
        在庫状態
      */

      if (!variant.available) {

        if (status) {

          status.textContent =
            'この香りは、ただいまSOLD OUTです。';

        }

      } else {

        if (status) {

          status.textContent =
            '選択内容をご確認のうえ、カートへお進みください。';

        }

      }


      /*
        PRICE
      */

      if (priceText) {

        priceText.textContent =
          money(
            variant.price
          );

      }


      /*
        IMAGE
      */

      syncImages(
        button,
        variant
      );


      /*
        BOTTOM FORM
      */

      syncFinalForm(
        variant
      );

    }


    /* =========================
       SCENT BUTTON
    ========================= */

    buttons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {


            /*
              SOLD OUTなら
              選択させない
            */

            if (button.disabled) {
              return;
            }


            selected =
              button.dataset.efrScent || '';


            setButtonState(
              button
            );


            update();


            /*
              RESULTへスクロール
            */

            var result =
              root.querySelector(
                '[data-efr-result]'
              );


            if (result) {

              setTimeout(
                function () {

                  result.scrollIntoView({
                    behavior:
                      'smooth',

                    block:
                      'start'
                  });

                },
                100
              );

            }

          }
        );

      }
    );


    /* =========================
       BOTTOM SELECT
    ========================= */

    if (finalSelect) {

      finalSelect.addEventListener(
        'change',
        function () {


          var variant =
            findVariantById(
              finalSelect.value
            );


          /*
            未選択
          */

          if (!variant) {

            selected = '';


            setButtonState(
              null
            );


            update();


            return;

          }


          /*
            念のため
            SOLD OUTは選択不可
          */

          if (!variant.available) {

            finalSelect.value = '';

            selected = '';


            setButtonState(
              null
            );


            update();


            return;

          }


          var button =
            findButtonForVariant(
              variant
            );


          if (button) {

            selected =
              button.dataset.efrScent;


            setButtonState(
              button
            );


            update();


            return;

          }


          /*
            対応ボタンが
            見つからなかった場合
          */

          if (finalPrice) {

            finalPrice.textContent =
              money(
                variant.price
              );

          }


          if (finalAdd) {

            finalAdd.disabled =
              !variant.available;

          }


          if (
            variant.image &&
            finalImage
          ) {

            setImage(
              finalImage,
              variant.image,
              'ETERNAL FLOWER 専用レフィル 25ml'
            );

          }


          if (paymentButton) {

            paymentButton.style.display =
              variant.available
                ? ''
                : 'none';

          }


          refreshStock();

        }
      );

    }


    /* =========================
       CENTER ADD TO CART
    ========================= */

    if (add) {

      add.addEventListener(
        'click',
        async function () {


          var id =
            Number(
              add.dataset.variantId
            );


          if (!id) {
            return;
          }


          var currentVariant =
            findVariantById(
              id
            );


          if (
            !currentVariant ||
            !currentVariant.available
          ) {

            return;

          }


          var originalLabel =
            add.textContent;


          add.disabled = true;


          add.textContent =
            '追加中…';


          try {


            var response =
              await fetch(
                '/cart/add.js',
                {

                  method:
                    'POST',


                  headers: {

                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'

                  },


                  body:
                    JSON.stringify({

                      items: [

                        {

                          id: id,

                          quantity: 1

                        }

                      ]

                    })

                }
              );


            if (!response.ok) {


              var body =
                await response
                  .json()
                  .catch(
                    function () {

                      return {};

                    }
                  );


              throw new Error(
                body.description ||
                'カートへの追加に失敗しました。'
              );

            }


            add.textContent =
              'カートに追加しました ✓';


            if (status) {

              status.textContent =
                'カートに追加しました。';

            }


            document.dispatchEvent(
              new CustomEvent(
                'cart:refresh'
              )
            );


            document.dispatchEvent(
              new CustomEvent(
                'cart:updated'
              )
            );


            setTimeout(
              function () {


                add.textContent =
                  originalLabel;


                var currentVariant =
                  findVariant();


                add.disabled =
                  !currentVariant ||
                  !currentVariant.available;

              },
              2500
            );


          } catch (error) {


            if (status) {

              status.textContent =
                error.message ||
                'カートへの追加に失敗しました。';

            }


            add.textContent =
              originalLabel;


            var currentVariant =
              findVariant();


            add.disabled =
              !currentVariant ||
              !currentVariant.available;

          }

        }
      );

    }


    /* =========================
       INITIAL STATE
    ========================= */

    /*
      ページ表示時は
      上も下も未選択から
    */

    selected = '';


    setButtonState(
      null
    );


    if (finalSelect) {

      finalSelect.value = '';

    }


    if (finalAdd) {

      finalAdd.disabled = true;

    }


    if (paymentButton) {

      paymentButton.style.display =
        'none';

    }


    update();

  });

})();